import { Box, Button, Heading, Text, VStack, Icon } from '@chakra-ui/react';
import React, { useContext, useEffect } from 'react';
import { MainSection } from '../components/Cart/MainSecion';
import { Navbar } from '../components/Cart/Navbar';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { CartStepper } from '../components/Cart/CartStepper';
import { CartContext } from '../context/cart';
import { AddressSection } from '../components/Cart/AddressSection';
import { DateSection } from '../components/Cart/DateSection';
import { CartWrapper } from '../components/Cart/CartWrapper';
import { CheckoutSection } from '../components/Cart/CheckoutSection';
import { PaymentSection } from '../components/Cart/PaymentSection';
import { AiOutlineShoppingCart } from 'react-icons/ai';

export const Cart = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { activeStep, setAddPatientsDrawer, cartPlans, orderSuccess, setOrderSuccess, setPaymentStatus, setActiveStep } = useContext(CartContext);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get('openDrawer') === 'true') {
      setAddPatientsDrawer(true);
      navigate('/cart', { replace: true });
    }

    // Cleanup function to reset success state when navigating AWAY from cart
    return () => {
      // We only want to reset if they are actually leaving the cart process
      // But for simplicity, resetting here ensures they don't see success screen next time they visit cart
      setOrderSuccess(false);
      setPaymentStatus('pending');
      setActiveStep(1);
      sessionStorage.removeItem('lastOrderIds');
    };
  }, [location, setAddPatientsDrawer, navigate, setOrderSuccess, setPaymentStatus, setActiveStep]);

  return (
    <>
      <Box 
       color={'white'}
       width={'100vw'}
       justifyContent={'center'}
      >
        <Navbar />
         {cartPlans?.length > 0 || orderSuccess ? (
          <>
            {!orderSuccess && <CartStepper />}
            {!orderSuccess && activeStep === 1 && <MainSection />}
            {!orderSuccess && (
              <>
                <CartWrapper display={activeStep === 2}>
                  <AddressSection />
                </CartWrapper>
                <CartWrapper display={activeStep === 3}>
                  <DateSection />
                </CartWrapper>
                <CartWrapper display={activeStep === 4}>
                  <CheckoutSection />
                </CartWrapper>
                <CartWrapper display={activeStep === 5}>
                  <PaymentSection />
                </CartWrapper>
              </>
            )}
             {orderSuccess && cartPlans?.length === 0 && (
               <Box px={['2', '12', '12', '24']} py={10}>
                 <PaymentSection />
               </Box>
             )}
          </>
        ) : (
          <VStack 
            height="70vh" 
            justifyContent="center" 
            spacing={6}
            px={4}
          >
            <Box 
              bg="teal.50" 
              p={8} 
              borderRadius="full" 
              color="teal.500"
            >
              <Icon as={AiOutlineShoppingCart} boxSize={20} />
            </Box>
            <VStack spacing={2} textAlign="center">
              <Heading color="gray.800" size="xl">Your cart is empty</Heading>
              <Text color="gray.500" fontSize="lg">
                Looks like you haven't added any tests to your cart yet.
              </Text>
            </VStack>
            <Button
              as={Link}
              to="/"
              colorScheme="teal"
              size="lg"
              px={10}
              height="60px"
              borderRadius="full"
              fontSize="md"
              shadow="xl"
              _hover={{ transform: 'translateY(-2px)', shadow: '2xl' }}
            >
              Browse Tests & Packages
            </Button>
          </VStack>
        )}
      </Box>
    </>
  );
};
